import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ProductSettingsPage } from '@/features/product-settings/ProductSettingsPage';
import { REGISTERS } from '@/features/product-settings/registers';

/** Which register shows, carried in the URL as the design does (?register=colours). Anything else lands on the first. */
const settingsSearch = z.object({
    register: z.enum(REGISTERS).catch(REGISTERS[0]),
});

export const Route = createFileRoute('/_app/products/settings')({
    validateSearch: (search) => settingsSearch.parse(search),
    component: SettingsRoute,
});

function SettingsRoute() {
    const { register } = Route.useSearch();
    return <ProductSettingsPage register={register} />;
}
